import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header({ dark = false }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  // On the home page, scroll within it instead of navigating
  const scrollTo = (id) => (e) => {
    close();
    if (pathname !== '/') return;
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const links = [
    { to: '/', label: 'Home', onClick: scrollTo('home') },
    { to: '/team', label: 'Team', onClick: close },
    { to: '/science', label: 'Science', onClick: close },
    { to: '/#contact', label: 'Contact', onClick: scrollTo('contact') },
  ];

  // The open menu is a dark overlay, so the header must switch to its light-on-dark style
  const isDark = dark && !menuOpen;

  return (
    <>
      <header className={`site-header${isDark ? ' site-header--dark' : ''}`}>
        <Link to="/" onClick={scrollTo('home')}>
          <img src="/images/company_logo.png" alt="Vellum Biotechnology" className="site-logo" width="355" height="170" />
        </Link>
        <nav className="site-nav">
          {links.map(({ to, label, onClick }) => (
            <Link key={label} to={to} className="nav-link" onClick={onClick}>{label}</Link>
          ))}
        </nav>
        <button
          className={`hamburger${menuOpen ? ' hamburger--open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
        </button>
      </header>
      <div
        className={`mobile-menu${menuOpen ? ' mobile-menu--open' : ''}`}
        onClick={close}
        aria-hidden={!menuOpen}
        inert={!menuOpen}
      >
        {links.map(({ to, label, onClick }) => (
          <Link key={label} to={to} className="mobile-nav-link" onClick={onClick}>{label}</Link>
        ))}
      </div>
    </>
  );
}

export default Header;
